import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import { CommonModalData } from '../../../types';
import * as types from '../../types';
import { aboutUsFormSceneSchema } from './validation';

type Props = {
  modalData: CommonModalData;
};

function useAboutUsForm({ modalData }: Props) {
  const {
    initialValues,
    data: { details: page },
  } = modalData;

  const name = React.useMemo(() => {
    if (!initialValues) return '';
    if ('attachedPages' in initialValues) return initialValues?.attachedPages?.[0]?.name || '';
    if ('attachedPage' in initialValues) {
      return initialValues?.attachedPage?.name || '';
    }
    if (initialValues.name) return initialValues.name;

    return '';
  }, [initialValues]);

  const defaultValues: types.AboutUsFormValues = page
    ? {
        name,
        ...page,
        emergencyContact: page?.emergencyContacts?.[0],
        tags: page.tags,
        type: types.EPageType.ABOUT_US,
      }
    : {
        tags: [],
        emergencyContact: {
          email: '',
          name: '',
          phone: '',
        },
        ...initialValues,
        name,
        type: types.EPageType.ABOUT_US,
      };

  const methods = useForm<types.AboutUsFormValues>({
    defaultValues,
    resolver: yupResolver(aboutUsFormSceneSchema),
    mode: 'onTouched',
  });

  return methods;
}

export { useAboutUsForm };
